<template>
<div>
  <table class="rt-table">
    <caption class="rt-caption">{{section_name}}</caption>
    <!-- <thead>
      <tr>
        <th class="rt-th">Sl</th>
        <th class="rt-th">Tr No</th>
        <th class="rt-th">From -> To</th>
        <th class="rt-th">L/Stn</th>
        <th class="rt-th">Late</th>
      </tr>
    </thead> -->
    <tbody>
      <tr v-for="item, i in section" onclick="onRowClick(item);">
        <td class="rt-td">{{i+1}}</td>
        <td class="rt-td">{{item.train_no}}</td>
        <td class="rt-td-org-dest">{{item.org}}->{{item.dest}}</td>
        <td class="rt-td">{{item.last_stn_code}}</td>
        <td class="rt-td">{{getTimeInMin(item.last_arr_dep_time)}}</td>
        <td class="rt-td">{{getFormattedTimeSec(item.status)}}m</td>
      </tr>
      <tr v-if="!section" class="tr-item" v-for="item, i in section">
        <td colspan="4">No Train</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'trlist',
  props: ['section', 'section_name'],
  data() {
    return {

    }
  },
  methods: {
    onRowClick($event) {
      //       console.log($event);
      // this.updateCurTrainNo($event.train_no)
      this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
      // this.updateCurDeviceId($event.device_id)
      // this.updateCurDeviceName($event.device_name)
      this.updateCurOrg($event.org)
      this.updateCurDep($event.dep)
      this.updateActDep($event.act_dep)
      this.updateCurDest($event.dest)
      this.updateCurArr($event.arr)
      this.updateActArr($event.act_arr)
      this.$router.push({
        name: 'Positions',
        query: {
          train_no:$event.train_no,
          device_id:$event.device_id,
          device_name:$event.device_name
        }
      })
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('m')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('m')
      }
    },
    getTimeInMin(t) {
      if (t) {
        return t.substring(0, 5)
      }
    }
  }
}
</script>
<style>
.tr-item {
  /* background: tomato; */
  width: 250px;
  /* height: 150px; */
  /* margin-top: 10px; */

  /* color: white; */
  width: 250px;
  font-size: .15em;
  text-align: left;
}

.rt-table {
  border-collapse: collapse;
  overflow: scroll;
  width:220px;
  /* height: 100px; */
}

.rt-caption {
  text-align: center;
  border: 1px solid #999;
  font-weight: 800;
  background-color:#1565c0;
  color:white;
  white-space: nowrap;
}

.rt-tr {
  height: 3px;
}

.rt-td {
  border: 1px solid #999;
  padding-left: 0.15rem;
  text-align: left;
  font-weight:500;
  white-space: nowrap;
  font-size: 50%;
}
.rt-td-org-dest {
  border: 1px solid #999;
  padding-left: 0.15rem;
  text-align: left;
  font-weight:500;
  white-space: nowrap;
  font-size: 8px;
}
.rt-th {
  border: 1px solid #999;
  background-color:#0d47a1;
  color:white;
  padding: 0.15rem;
  text-align: left;
  font-weight:900;
  white-space: nowrap;
}
</style>
